import { FormGroup } from '../../templates/form-group/form-group';
import type {
  SelectButtonContainerProps,
  SelectButtonOptionProps,
  SelectButtonProps,
} from './select-button.types';

function Option({
  label,
  value,
  onChange,
  onClick,
  inputId,
  disabled,
  name,
  inputProps,
}: SelectButtonOptionProps) {
  return (
    <div
      key={`${inputId}-${value}-container`}
      className="hc-cluster-layout flex-1"
      style={{
        '--hc-cluster-layout-space': '0',
      }}
    >
      <input
        {...inputProps}
        type="radio"
        id={`${inputId}-${value}`}
        onChange={onChange}
        onClick={onClick}
        name={name}
        value={value}
        disabled={disabled}
      />
      <label className="hc-label" htmlFor={`${inputId}-${value}`}>
        {label}
      </label>
    </div>
  );
}

function Container({
  children,
  disabled,
  errorText,
  label,
  helpText,
  showErrors,
}: SelectButtonContainerProps) {
  return (
    <FormGroup disabled={disabled} error={showErrors}>
      <fieldset className="hc-form-control__select-button">
        <legend className="hc-label"> {label}</legend>
        <div className="hc-form-control__select-button-container">
          {children}
        </div>
      </fieldset>
      <span className="hc-help-text"> {helpText}</span>
      <span className="hc-error-text">{errorText}</span>
    </FormGroup>
  );
}

export function SelectButton(properties: SelectButtonProps) {
  const { errorText, error, name, options, disabled, onChange, onClick, id } =
    properties;
  const showErrors = error || !!errorText;
  const inputId = id || name;
  const containerProperties = { ...properties, showErrors };

  const { ContainerView, OptionView } = properties;
  const SelectContainer = ContainerView ?? Container;
  const SelectOption = OptionView ?? Option;

  return (
    <SelectContainer {...containerProperties}>
      {options.map(({ value, label: optionLabel, ...inputProps }) => (
        <SelectOption
          key={value}
          disabled={disabled}
          inputId={inputId}
          inputProps={inputProps}
          label={optionLabel}
          name={name}
          onChange={onChange ?? inputProps.onChange}
          onClick={onClick ?? inputProps.onClick}
          value={value}
        />
      ))}
    </SelectContainer>
  );
}
